import { Header } from "../components/header";
import { Features } from "../components/features";
// import { Image } from "../components/image";
import { About } from "../components/about";
// import { Gallery } from "../components/gallery";
import { Ski } from "../components/ski";
import { Testimonials } from "../components/testimonials";
import { Contact } from "../components/contact";
import { Documents } from "../components/documents";
import { Events } from "../components/events";
import Albums from "../components/albums";

export default function LandingPage({ landingPageData }) {

    return (
        <>
            <Header data={landingPageData.Header} />
            <About data={landingPageData.About} />
            <Ski data={landingPageData.Ski} />
            <Features data={landingPageData.Features} />
            <Testimonials data={landingPageData.Testimonials} />
            <Events data={landingPageData.Events} />
            {/* <Gallery data={landingPageData.Gallery} /> */}
            <Albums />
            {/* <Image data={landingPageData.Image} /> */}
            <Documents />
            <Contact data={landingPageData.Contact} />
        </>
    );
}